import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
var styles = {
  inputTypeDate: function inputTypeDate() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      width: 0px;\n      height: 0px;\n      padding: 0px;\n      margin: 0px;\n      line-height: 0px;\n      transform: scale(0);\n      border: none;\n      overflow: hidden;\n      opacity: 0;\n    "])));
  }
};
export var jsStyles = memoizeStyle(styles);